import { render, staticRenderFns } from "./ReporterBooklist.vue?vue&type=template&id=aa2f0fb2"
import script from "./ReporterBooklist.vue?vue&type=script&lang=js"
export * from "./ReporterBooklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports